module.exports = __webpack_public_path__ + "assets/img/than.a4988156.jpg";